import _ from 'underscore';

import { withUiBlock } from '@bingads-webui/uiblocker';
import { DeterministicView, helpers } from '@bingads-webui/deterministic-view';

/* @this BaseCard */
function cardReady() {
  if (!this.perfMarkerCompleted) {
    this.unblockCard();
    this.perfMarker.done({ IsCardInViewPort: this.isInViewPort === true });
    this.perfMarkerCompleted = true;
    this.trigger('cardReady', this.typeId);
    if (this.onCardReady) {
      this.onCardReady(this.typeId);
    }
  }
}

let i18n;
let eventDispatcher;

export class BaseCard extends DeterministicView {
  constructor(options) {
    i18n = options.deps.i18n; // eslint-disable-line
    eventDispatcher = options.deps.eventDispatcher; // eslint-disable-line
    super(_.extend({}, options, { renderInSync: true }));
    this.deps = options.deps;
    this.container = options.container;
    this.typeId = options.typeId;
    this.isInViewPort = options.isInViewPort;
    this.onCardReady = options.onCardReady;
    this.initPerfMarker(options);

    this.on('attached', () => {
      this.attached = true;
      if (this.finishedRender) {
        cardReady.call(this);
      } else {
        this.blockCard();
      }
    });
  }

  initPerfMarker({ perfMarker, name }) {
    if (!this.perfMarker) {
      this.perfMarker = perfMarker.createChild(name);
      this.perfMarker.willInit();
      this.perfMarkerCompleted = false;
    }
  }

  willRenderWithData() {
    if (!this.perfMarkerCompleted) {
      this.perfMarker.willRender();
    }
  }

  willFetchData() {
    if (!this.perfMarkerCompleted) {
      this.perfMarker.willFetchData();
    }
  }

  renderedWithData() {
    this.finishedRender = true;
    if (this.attached) {
      cardReady.call(this);
    }
  }

  blockCard(el = this.el) {
    if (!this.unblock) {
      if (document.documentElement.contains(el)) {
        this.unblock = withUiBlock(el, i18n.getString('Loading'), true, undefined, 10);
      } else if (document.documentElement.contains(_.first(this.container))) {
        this.unblock = withUiBlock(this.container, i18n.getString('Loading'), true, undefined, 10);
      }
    }
  }

  isSmartShoppingCampaign() {
    const { currentCampaign } = this.options;
    return currentCampaign && (currentCampaign.CampaignSubType === 12 || currentCampaign.CampaignSubType === 'ShoppingSmartAds');
  }

  unblockCard() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  }

  updateState(patch) {
    if (patch.requestingHelp) {
      this.$('.hiddenHelpBridge')[0].click();
    }
    return helpers.updateView(this, patch);
  }

  onResize(callback) {
    this.windowResizeHandler = _.throttle(callback, 100);
    this.wunderbarCallback = callback;
    window.addEventListener('resize', this.windowResizeHandler);
    eventDispatcher.on('wunderbar.collapsed', this.wunderbarCallback);
    eventDispatcher.on('wunderbar.expanded', this.wunderbarCallback);
  }

  remove() {
    if (this.windowResizeHandler) {
      window.removeEventListener('resize', this.windowResizeHandler);
    }

    if (this.wunderbarCallback) {
      eventDispatcher.off('wunderbar.collapsed', this.wunderbarCallback);
      eventDispatcher.off('wunderbar.expanded', this.wunderbarCallback);
    }

    this.unblockCard();

    super.remove();
  }
}
